<template lang="pug">
modal(id="calcsamplesmodal" name="CalcSamplesModal" :pivotY="0.5" class="samples" :width="smallScreen ? '100%' : 780" height="auto" @before-open="beforeOpen"  @before-close="beforeClose"  :class="(smallScreen ? 'fullscreen' : '') + (activeModal === 'CalcSamplesModal' ? ' activeModal' : ' inactiveModal')")
  calc-modal
  div#geno-spinner(style="text-align: center")
    .spin-container(style="width: 72px; height: 100vh; display: inline-block;")
      geno-logo.spinner(:class="spinner ? 'rotateLoading' : ''" style="width: 72px; height: 72px;" )
  .row()
    n-button.deletesamples(v-if="tableData.length > 0" type='primary' icon='' round @click.native="deleteAll()"  v-tooltip="{content: 'Toggle calculators<br/>for deletion', classes: [ 'modaltip' ]}" :class="''") 
      i(:class="'fa fa-ban'" style="opacity:1")
    .col-12(style="text-align: center;")
      el-table(:data='pageData' :empty-text= "search && search.length > 0 ? 'No calculators found matching search criteria' : 'Click on the icon(s) below to add your calculators(s)'" :style="`height:${height}px;`")
        el-table-column.data-header.sample(class='data-header' width='260' label='Calculator')
          span.sample(slot-scope="{row}" v-tooltip="'Click to get sharable link for ' +  row.label" @click="copyCalc({label: row.label, user: row.user})" :class = "row.action && row.action === 'delete' ? 'deleted' : ''" )
            a.copycalc() {{(row.label).length > 23 ? (row.label).substring(0,26) + '...' : row.label}}
        el-table-column.data-header.public(width='90' label='Public')
          span.public(slot-scope="{row}" v-tooltip="")
            i(v-if="row.public === 1" class="fas fa-check")
            i(v-if="row.public === 0" class="fas fa-minus")
        el-table-column.data-header.public(width='195' label='Type')
          span.type(slot-scope="{row}" v-tooltip="")  {{row.type ? row.type : 'G25'}}
        el-table-column.data-header.actions(width='160' header-align='center' label='Actions')
          .text-left.table-actions(slot-scope='{row}')
            i(v-if="!row.action || (row.action && row.action !== 'delete')" class="far fa-edit" v-tooltip="{content:'edit sample', classes: [ 'modaltip' ]}" v-on:click="row.external ? uneditable('edit', row) : editModal('edit', row)")
            i(v-if="!row.action || (row.action && row.action !== 'delete')" class="fa fa-trash" v-tooltip="{content:'delete sample', classes: [ 'modaltip' ]}" v-on:click="log('delete',row)")
            i(v-if="!row.action || (row.action && row.action !== 'delete')" class="fa fa-download" v-tooltip="{content:'download Datasheet', classes: [ 'modaltip' ]}" v-on:click="writeSheet(row)")
            i(v-if="row.action && row.action === 'delete'" class="fas fa-undo" v-tooltip="{content:'undo delete', classes: [ 'modaltip' ]}" v-on:click="log('undelete',row)")
  .row(style="text-align: center; position: relative; height: 175px; bottom: 25px; width: 100%;")
    div.search(style="margin:auto;margin-bottom: 10px;width: 100%;")
      i(class="fas fa-search")
      input.search(type="text" v-model="search" spellcheck="false" autocomplete="false" @dblclick="clearSearch()")
    .buttons(style="display:inline-block; text-align: center; margin: auto;" )            
      n-button(type='info' class='primary'  @click.native="closeModal()"  v-tooltip="{content: 'cancel changes' , classes: [ 'modaltip' ]}") Cancel
      n-button.primary.unchanged(v-if="!changed" type='default' style="opacity:0.3" ) Save
      n-button.primary.changed(v-if="changed" type='info' @click.native="save()"  v-tooltip="{content: 'save changes' , classes: [ 'modaltip' ]}") 
        geno-spinner(:loading="saving" :text="'Save'" :size="32")
      n-button.addsample(type='primary' icon='' round @click.native="editModal('add', {})"  v-tooltip="{content: 'add new samples' , classes: [ 'modaltip' ]}") 
        i(class="fa fa-plus" style="opacity:1")
    .pagination(style="text-align: center; position: relative; bottom: 0px; width: 100%;")
      n-pagination(:page-count="pages" v-model="defaultPagination" style="margin: auto;" v-on:input="log(defaultPagination)")
</template>
<script>
import {Table, TableColumn} from 'element-ui'
import { Button, Pagination } from '@/components'
import modifyCalcsMutations from "@/graphql/modifyCalcsMutations"
import getOwnerSamplesQuery from "@/graphql/getOwnerSamplesQuery"
import getCalcQuery from "@/graphql/getCalcQuery"
import getRefsQuery from "@/graphql/getRefsQuery"
import CalcModal from './calculator.vue'
import copy from 'copy-html-to-clipboard';

export default {
  name: 'CalcSamplesModal',
  created: function() {
  this.$store.commit('change', { changes: {} })
  },
  mounted: function() {
  },
  components: {
      CalcModal,
      [Table.name]: Table,
          [TableColumn.name]: TableColumn,
          [Button.name]: Button,
          [Pagination.name]: Pagination,
            },
  data () {
    return {
    smallScreen: window.innerWidth < 480 ? true : false,
    markedAll: false,
    saving: false,
    spinner: false,
		closable: false,
		defaultPagination: 1,
    search: null,
    }
  },
	computed: {
    onLine: {
    get: function() {
    return this.$store.getters.get("onLine");
    }
    },
    tableData: {
    get: function() {
    let data =  JSON.parse(JSON.stringify(this.$store.getters.get("editCalcs")));
    data = data ? data : []
    if ( data.length > 1 ) {
    data = data.filter( x => x !== null && x !== undefined)
    data.sort( (a,b) => a.calculator > b.calculator ? 1 : -1 )
		if ( this.search ) data = data.filter( x => x.calculator.toLowerCase().indexOf(this.search.toLowerCase()) >=0 )
		
    //if ( this.search ) data = data.filter( x => x.calculator.toLowerCase().indexOf(this.search.toLowerCase()) >=0 || (x.type ? x.type.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false) || (x.ethnicity ? x.ethnicity.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false) || (x.origin ?  x.origin.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false) )
    }
    return data
    return JSON.parse(JSON.stringify(this.$store.getters.get("editCalcs")));
    },
    set: function(value) {
    this.$store.commit('change', { editCalcs: value  })
    },
    },
    mode: {
        set: function(value) {
        this.$store.commit('change', {monteMode: value})
        },
        get: function(value) {
        return this.$store.getters.get('monteMode') ? this.$store.getters.get('monteMode') : 'G25'
        }
        },
    activeModal: function() { return this.$store.getters.get('activeModal') },
    changes: function() { return  this.$store.getters.get('changes') },
    user: function() { return  this.$store.getters.get('user') },
    changed: function() {
    if ( this.changes && Object.keys(this.changes).length > 0 ) {
    return true
    } else {
    return false;
    }
    },
		pageData: function() {
			var page = this.defaultPagination;
			var start = page * 8 - 8
			var end = start + 8;
			return this.tableData.slice(start, end)
		},
    pages: function() {
    return this.tableData && this.tableData.length > 0 ? Math.ceil(this.tableData.length/4) : 0;
    },
    height: function() {
    let rowsize = this.smallScreen ? 42.5 * 0.75 : 42.5;
    let length = this.$store.getters.get("editCalcs").length
    let height = this.search && this.search.length > 0 ? ( length >= 8 ? (8 * rowsize) + 150 :  (length * rowsize) + 150 ) : this.tableData.length >= 8 ? (8 * rowsize) + 150 : this.pageData.length > 0 ?  parseInt((this.pageData.length * 42.5) + 150) : 280;
    return height
    }
		},
  methods: {
        copyCalc: function(data) {
        let url = `https://genoplot.com/g25?calculator=${data.user}:${encodeURI(data.label)}` 
        copy(url);
            this.$modal.show('dialog', {
                class: 'alert',
                title: 'Link to sharable calculator',
                text: `The <a target='_blank' href=${url}> link </a> for this calculator has been copied to the clipboard<br/>`,
            })
        },
        deleteAll() {
        let w = this;
        let action = this.tableData && this.tableData[0] && this.tableData[0].action == 'delete' ? 'undelete' : 'delete'
        this.tableData.forEach( row => {
        w.log(action, row)
        })
        this.markedAll = !this.markedAll
        },
        clearSearch() {
        this.search = ''
        },
        getXLS: () => {
            return new Promise((resolve, reject) => {
                if (!window.XLSX) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(true)
                }
            })
        },
debounceSearch(event) {
      this.search = null
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.search = event.target.value
      }, 0)
		},
debounce: (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
},
    writeSheet: async function(row) {
                let w = this;
                let errorArr = []
            if (!this.onLine) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + Date.now();
            this.$store.commit('change', {
                subId: subId
            })
                var params = {
                    sub: subId,
                    calculator: row.calculator,
                    sample: row.user,
                    creator: row.user,
                }
                this.spinner = true;
                this.getXLS().then(async (res) => {
                    var wb = XLSX.utils.book_new();
                        const data = await w.$apollo.query({
                            query: getCalcQuery,
                            variables: {
                                params: JSON.stringify(params)
                            }
                            })
                this.spinner = false;
                        if (data.data && data.data.getCalc && data.data.getCalc.result) {
                            let output = data.data.getCalc.result;
                    let buffer = Buffer.from(output, 'base64')
                    let jsonStr = w.$zlib.unzipSync(buffer).toString()
                    let result = JSON.parse(jsonStr)
                            if ( result ) {
                            result = result.map( x => { let sample = { sample: x.sample }; x.coords.split(',').map( (y,i) => { sample[`PC${i  + 1}`] = parseFloat(y)  }); return sample })
                    var ws = XLSX.utils.json_to_sheet(result, {skipHeader:false});
                    XLSX.utils.book_append_sheet(wb, ws, "results");
                    XLSX.writeFile(wb, "calculator_datasheet.csv", {
                        compression: true
                    });
                        } else {
                            errorArr.push(`calculator ${row.label} not found`)
                            }
                        } else {
                            errorArr.push(`calculator ${row.label} not found`)
                this.spinner = false;
                            return false;
                        }
                        if (errorArr.length > 0) {
                            var errMessage = ''
                            errorArr.forEach(error => {
                                errMessage = errMessage + error + '<br>';
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: errMessage,
                                    class: 'failure'
                                }
                            })
                        }
                        })
                },
  uneditable: async function(action, data) {
      this.spinner = true;
      var index = data.index;
      let query = getRefsQuery;
      let variables = {
                            params: JSON.stringify( { creator: this.user.username, calculator: data.calculator, usercalc: true, id: this.user.username + Date.now() } )
                        }
      let dataCSV = await this.$apollo.query({
          query: query,
          variables: variables
      })
      console.log(dataCSV)
      this.spinner = false;
      if ( dataCSV && dataCSV.data && dataCSV.data.getRef && dataCSV.data.getRef.result && dataCSV.data.getRef.result.split('||').length > 1 ) {
      let result = dataCSV.data.getRef.result
      result = result.replace(/\|\|/g, '\n').replace(/\"/g,'').replace(/\'/g,'')
    this.$nextTick( () => this.$modal.show('CalcModal', { action: action, index: index, groupJSON: this.groupJSON, sampleJSON: this.sampleJSON, dataCSV: result }))
    }
                /*var text = "This calculator was created from a custom CSV file and cannot be edited from this interface."
                var title = "Not Editable"
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        class: "alert",
                        title: title,
                        text: text
                    }
                })
                */

    },
    addGhost: function() {
    this.$modal.show('ghostmodal', {groupOptions: this.groupOptions}) },
		feature: function(el) {
            this.$eventBus.$emit('appEvents', {
                exec: 'featureRequest',
                component: 'g25',
                params: el
            })
		},
  save: function() {
  this.closable = true;
  this.saving = true;
  var w = this;
  this.updateSamples()
/*
  setTimeout(function() {
  w.$eventBus.$emit('appEvents', { exec: 'updateSamples', component: 'g25' })
  }, 1000)
  */
  },
  editModal: function(action, data) {
      var index = data.index;
    this.$nextTick( () => this.$modal.show('CalcModal', { action: action, index: index, groupJSON: this.groupJSON, sampleJSON: this.sampleJSON }))
      },
edit: function(action) {
    this.$modal.show('CalcModal')
    },
show: function(params) {
var w = this;
var title = params.title ? params.title : 'Alert!'
var text = params.text ? params.text : 'Message received...'
var buttons = [ 
    {
      title: 'Continue',
      default: false,    // Will be triggered by default if 'Enter' pressed.
      handler: () => { w.closable = true; 
      w.$modal.hide('dialog');
      w.closeModal(true);
      } 
    },
    {
      title: 'Cancel',
      default: true,
      handler: () => { w.closable = false;w.$modal.hide('dialog'); } // Button click handler
    }
 ]
this.$modal.show('dialog', {
  title: title,
  text: text,
  class: params.class ? params.class : undefined,
  buttons: buttons
})
},
		log: function(params, row) { 
    if ( params === 'delete' || params === 'undelete' ) { 
    let calcs =  JSON.parse(JSON.stringify(this.$store.getters.get("editCalcs")));
		let index = calcs.findIndex( x => x.index === row.index )
    row.action = params === 'delete' ? 'delete' : undefined
    calcs[index] = row;
    let changes = {...this.changes}
		if ( params === 'delete' ) {
    changes[row.calculator] = row
		} else {
    delete changes[calcs[index].calculator] 
		}
    this.$store.commit('change', { changes: changes })
		this.tableData = calcs;
    } else {
		return
		}
    },
		beforeClose: function(event) {
      if (this.closable === false) {
        event.stop()
      } else {
			this.closable = false
			}
    },
		beforeOpen: function(event) {
    this.spinner = false;
    this.markedAll = false;
    this.$store.commit('change', { activeModal: 'CalcSamplesModal' })
    this.groupJSON = event.params.groupJSON;
    this.sampleJSON = event.params.sampleJSON;
    this.saving = false;
    this.$store.commit('change', { changes: {} })
    var data = JSON.parse(JSON.stringify(this.$store.getters.get("userCalcs")))
    if ( this.mode === 'G25' ) {
    data = data.filter( x => x.type === this.mode || x.type === undefined || x.type === null )
    } else {
    data = data.filter( x => x.type === this.mode )
    }
    data.forEach((sample, index) => {
    sample.index = index;
    sample.label = unescape(sample.calculator);
    })
    this.tableData = data;
    if ( event.params.add ) {
    setTimeout( () =>  { this.editModal('add', {})}, 100)
    }
    },
		closeModal: function(flag) { 
		var closable = flag ? flag : false
    if ( this.changed && !closable ) {
    this.show({ title: 'Are you sure?', text: 'You have unsaved changes, these will be lost if you continue.', class: 'warning' });
    return;
    } else {
    this.closable = true;
    this.defaultPagination = 1;
		this.$modal.hide('CalcSamplesModal') 
    }
			},
        updateSamples() {
            var w = this;
            var changes = this.$store.getters.get('changes');
            console.log('changes', changes);
            let total = Object.keys(changes).length
            var userCalcs = this.$store.getters.get('userCalcs');
            var records = []
            Object.keys(changes).forEach(change => {
                if (changes[change].action === 'delete') {
                    if (userCalcs.findIndex(calc => calc.calculator === change) >= 0) {
                        records.push(change);
                    }
                    }
            })
            async function processChanges() {
                let results = []
                let errors = []
                const sendUpdates = records.map(async record => {
                        var params = {
                            user: w.user.username,
                            calculator: record
                        }
                        console.log('params', params);
                    var mutation = modifyCalcsMutations['delete'];
                    let data = await w.$apollo.mutate({
                            mutation: mutation,
                            variables: {
                                input: params
                            }
                        })
                        .then(data => {
                            if (data && data.data.deleteGenoplotCalc && data.data.deleteGenoplotCalc.calculator) {
                                results.push(data.data)
                            } else {
                                errors.push(data)
                            }
                        }).catch(err => {
                            errors.push(err)
                            w.$sentry.captureException(err);
                            console.log(err)
                        })
                })
                let updated = await Promise.all(sendUpdates);
                console.log(`Successfully processed ${total} records.`)
                if (results.length === records.length) {
                    var klass = 'alert'
                } else {
                    var klass = 'warning'
                }
                var message = `Processed ${total} change(s)`
                var errormsg = errors.length > 0 || results.length < records.length ? `<br/>with ${records.length - results.length} error(s)` : ''
                var text = message + errormsg;
                var title = klass === 'alert' ? 'Success!' : 'Error!'
                w.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        class: klass,
                        title: title,
                        text: text
                    }
                })
                w.$eventBus.$emit('appEvents', { exec: 'init', component: 'g25' })
                w.$modal.hide('CalcSamplesModal')
            }
            processChanges();
        },
          }
}
</script>
<style lang="scss">

#calcsamplesmodal.fullscreen .row {
zoom: 75%;
}
#calcsamplesmodal.fullscreen .v--modal {
border-radius: 0px;
}

#app .buttons button.primary {
width: 90px;
}
#app .samples .v--modal button.closedialog:hover {
box-shadow: none;
}
#app .samples .v--modal button.closedialog:active {
background: #9797971c;
}

#app #calcsamplesmodal .buttons button {
margin-left: 10px;
margin-right: 10px;
font-weight: 700;
box-shadow: none;
transition: background 0.3s;
}

#app .buttons button.unchanged {
cursor: default;
}
#app .buttons button.changed {
background: #73a008;
}
.fa-info {
color: green;
}
.samples .fa, .samples .far, .samples .fas {
font-size: 16px;
padding: 0px 12px;
opacity: 0.7;
cursor: pointer;
}
.samples .fa:hover, .samples .far:hover, .samples .fas:hover {
opacity: 1;
}
#app .samples .el-table {
padding-top: 0;
padding-bottom: 24px;
}
#app .samples .el-table .cell {
cursor: default;
}

#app .samples .el-table__empty-text {
    line-height: 24px;
        font-size: 18px;
            width: 70%;
                margin-left: -42px;
                    color: #909399;
                    }
.fa-edit {
color: steelblue;;
}
.fa-trash {
color: #E65929;
}
#app .el-table::before { height: 0px; }
.v--modal button.closedialog {
    background: transparent;
    position: absolute;
    top: 0px;
    right: 0px;
    display: inline;
    float: right;
    z-index: 9;
}
.samples {
border-radius: 5px;
}

.samples .col-12 {
transition: height 0.3s;
}

.samples .v--modal {
transition: top 0.3s;
}
.el-table {
    background-color: transparent !important;
        padding: 30px;
        }
.v-datatable-light .header-item {
  cursor: pointer;
  color: #337ab7;
  transition: color 0.15s ease-in-out;
}
.v-datatable-light .header-item:hover {
  color: #ed9b19;
}
.v-datatable-light .header-item.no-sortable{
  cursor: default;
}
.v-datatable-light .header-item.no-sortable:hover {
  color: #337ab7;
}
.v-datatable-light .header-item .th-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  font-weight: bold;
}
.v-datatable-light .header-item .th-wrapper.checkboxes {
  justify-content: center;
}
.v-datatable-light .header-item .th-wrapper .arrows-wrapper {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  justify-content: space-between;
}
.v-datatable-light .header-item .th-wrapper .arrows-wrapper.centralized {
  justify-content: center;
}
.v-datatable-light .arrow {
  transition: color 0.15s ease-in-out;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
}
.v-datatable-light .arrow.up {
  border-bottom: 8px solid #337ab7;
}
.v-datatable-light .arrow.up:hover {
  border-bottom: 8px solid #ed9b19;
}
.v-datatable-light .arrow.down {
  border-top: 8px solid #337ab7;
}
.v-datatable-light .arrow.down:hover {
  border-top: 8px solid #ed9b19;
}
.v-datatable-light .footer {
  display: flex;
  justify-content: space-between;
  width: 500px;
}
.tooltip .tooltip-inner { 
}
.tooltip.tipinfo .tooltip-arrow {
}
.tooltip.tipinfo .tooltip-inner {
color: white;
padding: 10px 12px;
background: #296192;
}
.tooltip.tipinfo .tooltip-arrow {
border-color: #296192;
}
.samples .deleted {
text-decoration: line-through;
opacity: 0.3;
}
.samples .el-table_1_column_2  {
text-align: center;
}
.samples span.sample {
    font-weight: 700;
    font-size: 0.95em;
        }
.samples .fas.fa-check {
color: green;
}
#app .samples button.btn.addsample {
background-color: #3987bf !important;
}
#app .samples .el-table td,#app .samples  .el-table th  {
padding: 16px 7px;
}
#app .samples .fa-edit, #app .samples .fa-trash {
color: #606266;
}
#app .samples .fa-minus {
opacity: 0.3;
cursor: default;
font-size: 0.7em;
}
#app .samples .data-header {
font-weight: 700;
    font-size: 20px;
    color: #0f5579;
}
body.app-page #app #calcsamplesmodala .v--modal-box.v--modal {
zoom: 90%;
margin-left: 5%;
}
body.app-page #app #calcsamplesmodal .el-table thead {
            text-transform: uppercase;
                font-size: 0.7em;
                font-weight: 700;
                color: gray !important;
         }
#app #calcsamplesmodal input.search {
    width: 250px;
    height: 36px;
    padding: 5px 10px;
    border-radius: 5px;
		border-style: solid;
    font-weight: 700;
    font-size: 1.2em;
    border-color: #00000021;
    color: rgba(0,0,0,0.5);
}         
#app #calcsamplesmodal input.search:active, #app #calcsamplesmodal input.search:focus {
outline: none;
border-color: #2362a782;
box-shadow: none !important;
text-shadow: none !important;
background-color: transparent;
}
#app #calcsamplesmodal .search i.fa-search {
opacity: 0.3;
cursor: default;
}

#app #calcsamplesmodal.inactiveModal {
opacity: 1;
}
#app #calcsamplesmodal.activeModal {
opacity: 1;
}
#app #calcsamplesmodal #geno-spinner .spin-container svg.rotateLoading {
visibility: visible;
}
#app #calcsamplesmodal #geno-spinner svg.spinner {
visibility: hidden;
}
#app #calcsamplesmodal #geno-spinner {
    position: absolute;
        z-index: 9;
            margin-left: calc(50% - 36px);
}

#app #calcsamplesmodal #geno-spinner, #app #calcsamplesmodal #geno-spinner .spin-container {
height: 100% !important;
pointer-events: none;
}
#app #calcsamplesmodal #geno-spinner svg.spinner  {
top: calc(50% - 36px);
}
#app .samples .btn.deletesamples {
position: absolute;
top: 2px;
right: 15px;
height: 1.5rem;
width: 1.5rem;
min-width: 1.5rem;
font-size: 0.5rem;
z-index: 999;
background-color: silver !important;
opacity: 0.5;
transition: all 0.3s;
}
#app .samples .btn.deletesamples:hover {
background-color: #3987bf !important;
opacity: 1;
}
#app .samples .btn.deletesamples.undelete:hover {
background-color: #73a008 !important;
}

#app .samples .btn.deletesamples .fa-ban, #app .samples .btn.deletesamples .fa-undo {
color: white;
font-size: 0.65rem;
margin-left: -0.5em;
margin-top: 0.06rem;
}
#app .samples a.copycalc {
cursor: pointer;
color: #3987bf;
}

</style>
